module.exports = __webpack_public_path__ + "static/media/in-content.1bd93033.svg";